<po-page-default>
  <div class="dashboard">

    <!-- Hero -->
    <section class="hero">
      <div class="hero-content">
        <p class="hero-greeting">Seja bem-vindo(a)</p>
        <h1 class="hero-name">{{userName}}</h1>
        <p class="hero-tagline">Plataforma <strong>Ecco Contabilidade</strong> — gestão contábil inteligente para escritórios que pensam grande.</p>
      </div>
      <div class="hero-visual">
        <img src="/dash.svg" alt="Dashboard" />
      </div>
    </section>

    <!-- Stats -->
    <section class="stats-bar">
      <div class="stat-item">
        <i class="an an-clock stat-icon"></i>
        <div>
          <span class="stat-value">{{currentDate}}</span>
          <span class="stat-label">Data atual</span>
        </div>
      </div>
      <div class="stat-item">
        <i class="an an-chart-line-up stat-icon"></i>
        <div>
          <span class="stat-value">Ecco Contab.</span>
          <span class="stat-label">Plataforma ativa</span>
        </div>
      </div>
      <div class="stat-item">
        <i class="an an-shield-check stat-icon"></i>
        <div>
          <span class="stat-value">Conectado</span>
          <span class="stat-label">Status da sessão</span>
        </div>
      </div>
    </section>

    <!-- Quick access -->
    <section class="quick-access">
      <h2 class="section-title"><i class="an an-squares-four"></i> Acesso Rápido</h2>

      <div class="cards-grid">
        <a class="card" *ngFor="let card of quickAccessCards" (click)="redirect(card.link)">
          <div class="card-header">
            <div class="card-icon"><i [class]="card.icon"></i></div>
            <span class="card-badge">{{ card.badge }}</span>
          </div>
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-desc">{{ card.description }}</p>
          <span class="card-link">Acessar <i class="an an-arrow-right"></i></span>
        </a>
      </div>
    </section>

  </div>
</po-page-default>
